import type {InputHTMLAttributes, ReactNode} from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: ReactNode;
  label?: string;
}

export function Input({icon, label, className, ...props}: InputProps) {
  return (
    <div className={styles.wrapper}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.inputWrap}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <input
          className={[styles.input, icon ? styles.withIcon : '', className ?? '']
            .filter(Boolean)
            .join(' ')}
          {...props}
        />
      </div>
    </div>
  );
}
